<ion-list
  [id]="stop().id"
  class="block-content-round"
  [ngClass]="{
    '--to-load': stop().type === EStopType.LOAD,
    '--to-unload': stop().type === EStopType.UNLOAD,
    '--to-unload_load': stop().type === EStopType.UNLOAD_LOAD,
  }"
>
  <ion-item-group>
    <ion-item-divider sticky>
      <div>
        <span class="step-number">{{ stop().position + 1 }}</span>
        <p class="subtitle">
          @if (stop().type === EStopType.LOAD) {
            {{ 'freight.detail.load' | translate }}
          } @else if (stop().type === EStopType.UNLOAD) {
            {{ 'freight.detail.unload' | translate }}
          } @else if (stop().type === EStopType.UNLOAD_LOAD) {
            {{ 'freight.detail.unload_load' | translate }}
          }
        </p>
      </div>
      @if (stop().type === EStopType.LOAD) {
        <ion-icon
          slot="end"
          aria-hidden="true"
          src="../assets/material-symbols/upload_24dp.svg"
        ></ion-icon>
      } @else if (stop().type === EStopType.UNLOAD) {
        <ion-icon
          slot="end"
          aria-hidden="true"
          src="../assets/material-symbols/download_24dp.svg"
        ></ion-icon>
      } @else if (stop().type === EStopType.UNLOAD_LOAD) {
        <ion-icon
          slot="end"
          aria-hidden="true"
          src="../assets/material-symbols/swap_vert_24dp.svg"
        ></ion-icon>
      }
    </ion-item-divider>

    <div class="freight">
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col
            size="12"
            size-lg="6"
          >
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/pin_drop_24dp.svg"
              ></ion-icon>

              <div>
                @if (isFreightAvailable()) {
                  <p>{{ stop().address.postalCode }} {{ stop().address.city }}</p>
                }
                <p class="ion-text-uppercase">
                  <strong>
                    ({{ 'countries.' + stop().address.countryCode | translate }})
                    {{ 'states.' + stop().address.countryCode + stop().address.stateCode | translate }}
                  </strong>
                </p>
              </div>
            </div>
          </ion-col>

          <ion-col
            size="12"
            size-lg="6"
          >
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/schedule_24dp.svg"
              ></ion-icon>

              <div>
                <!-- <p class="subtitle">{{ 'freight.detail.schedule' | translate }}:</p> -->
                <p class="subtitle">Horario de llegada:</p>
                <strong>
                  <time [dateTime]="stop().since?.toISOString() || ''">
                    {{ formattedRange() }}
                  </time>
                </strong>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-item-group>
</ion-list>
